/* Button style options */

export const availableTypeOptions = [
  'default',
  'flat',
  'text',
  'circle',
  'capsule',
]

export const availableSizeOptions = ['large', 'medium', 'small', 'tiny']
